module.exports = __webpack_public_path__ + "img/upload_photos_img.c4af9c3a.png";